import React, { useEffect, useState, useContext } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Notifications from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
// import Alert from "@material-ui/lab/Alert";
import jwt_decode from "jwt-decode";
import instance from "../api/api";
import { Context } from "../context/ContextProvider";
import Loading from "../components/Item";
import LoginIcon from "@mui/icons-material/Login";
const useStyles = makeStyles((theme) => ({
  "@global": {
    password: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  table: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
  },
  avatar: {
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  icons: {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    top: 5,
    right: 5,
  },
}));

const Login = () => {
  const {
    isAdmin,
    setIsAdmin,
    setIsLoading,
    token,
    setToken,
    isActive,
    setIsActive,
  } = useContext(Context);

  const [unmounted, setUnmounted] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [newOject, setNewObject] = useState({
    email: "",
    password: "",
  });

  // const {
  //   // messages,
  //   // setMessages,
  //   // user,
  //   // setUser,
  // } = useContext(Context);

  useEffect(() => {
    if (isLogin) setUnmounted(true);
    return () => {
      setIsLogin(true);
    };
  }, [isLogin]);
  let navigate = useNavigate();

  const classes = useStyles();
  const handleFields = (e) => {
    setNewObject({ ...newOject, [e.target.name]: e.target.value });
  };

  const sendNotification = async (e) => {
    e.preventDefault();
    setError("");

    const email = newOject.email;
    const password = newOject.password;
    if (email === "" || password === "") {
      alert("email/password cannot be empty");
      return;
    }

    setLoading(true);
    try {
      const req = await instance.post(`/users/login`, {
        email,
        password,
      });
      if (unmounted) {
        setIsLogin(false);
        setUnmounted(false);

        setNewObject({ email, password });
        localStorage.setItem("Token", req.data.accessToken);
        var decoded = jwt_decode(req.data.accessToken);
        setToken(req.data.accessToken);

        const isAdmin = decoded.user.admin;
        console.log("admin, ", isAdmin);
        console.log("token, ", req.data.accessToken);

        // const isAdmin = true;
        setLoading(false);

        setIsLoading(true);

        setIsAdmin(isAdmin);
        // setTimeout(() => {
        //   console.log("token dd: ", token);
        // }, 3000);
        setIsActive(true);
        navigate("/cart");

        // navigate("/list");
      } else {
        setError("You can't access this page.");
      }
    } catch (error) {
      // console.log("jjj", error.message);
      setNewObject({ email: "", password: "" });
      setLoading(false);
      setError(error.message);
      console.clear();
    }
  };

  if (isAdmin) {
    return <Loading />;
  }

  return (
    <Container style={{ paddingTop: 70, paddingBottom: 100 }}>
    {/* {error && (
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      )} */}

      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Login User
        </Typography>
        <Avatar className={classes.avatar}>
          <LoginIcon />
        </Avatar>

        <form
          className={classes.form}
          noValidate
          onSubmit={sendNotification}
          id="formR"
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="email"
            name="email"
            value={newOject.email}
            onChange={(e) => handleFields(e)}
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="password"
            name="password"
            value={newOject.password}
            onChange={(e) => handleFields(e)}
            autoComplete="password"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            style={{ background: "black", color: "#ffffff" }}
            className={classes.submit}
          >
            {loading ? (
              <CircularProgress style={{ color: "#ffffff" }} size={20} />
            ) : (
              "تسجيل دخول"
            )}
          </Button>
        </form>
        <Button
          // type="submit"
          fullWidth
          variant="outlined"
          style={{borderColor:"black" , color:'black',marginTop:10}}
          // style={{ background: "black", color: "#ffffff" }}
          className={classes.submit}
          onClick={() => navigate("/register")}
        >
          تسجيل جديد
        </Button>
      </div>
    </Container>
  );
};
export default Login;
